module.exports = __webpack_public_path__ + "static/waterteether3-b10d39d34b7953a802d0ded95b066678.jpeg";